import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const lunes = (off) => { const d = new Date(); d.setHours(12); d.setDate(d.getDate() - ((d.getDay() + 6) % 7) + off * 7); return d; };

export const useOcupacion = (centro, deps) => {
  const [sem, setSem] = useState(0);
  const [occ, setOcc] = useState({});
  const ini = lunes(sem);
  const fin = new Date(ini.getTime() + 5 * 86400000);
  const [desde, hasta] = [iso(ini), iso(fin)];
  useEffect(() => {
    api.get("/huecos-ocupacion", { params: { desde, hasta, centro } }).then((r) => setOcc(r.data));
  }, [desde, hasta, centro, deps]);
  return { sem, setSem, occ, desde, hasta };
};

export const SemanaNav = ({ o }) => (
  <div className="flex items-center gap-2 mb-2 text-xs text-slate-600" data-testid="ocupacion-nav">
    <span className="font-semibold uppercase tracking-wider text-slate-500">Ocupación</span>
    <button type="button" onClick={() => o.setSem(o.sem - 1)} className="rounded border border-slate-200 px-2 py-0.5" data-testid="ocupacion-prev">‹</button>
    <span data-testid="ocupacion-semana">{o.sem === 0 ? "Esta semana" : o.sem === 1 ? "Semana que viene" : "Semana"} · {fmtDate(o.desde)} – {fmtDate(o.hasta)}</span>
    <button type="button" onClick={() => o.setSem(o.sem + 1)} className="rounded border border-slate-200 px-2 py-0.5" data-testid="ocupacion-next">›</button>
    <span className="text-slate-400">Cuenta los huecos de evaluación, revisión, terapia, óptica y libres que ya tienen cita.</span>
  </div>
);

export const OcupacionProf = ({ x, id }) => {
  if (!x?.total) return <div className="text-[10px] opacity-70">sin huecos</div>;
  const pct = Math.round((x.llenos * 100) / x.total);
  return (
    <div className="mt-1" data-testid={`ocupacion-${id}`} title={`${x.llenos} con cita de ${x.total} huecos`}>
      <div className="h-1.5 rounded-full bg-black/15 overflow-hidden"><div className="h-full bg-current" style={{ width: `${pct}%` }} /></div>
      <div className="text-[10px] font-normal">{x.llenos}/{x.total} llenos · <b>{x.total - x.llenos} libres</b></div>
    </div>
  );
};
